import { OFetchRequestOptions, useOFetch } from '../../requests';
import { CustomFetchContext } from '../../requests/types';
import { ApiResponse } from '../../types';
import { Data, OtherData } from './types';

// 获取列表页信息
export const fetchListlInfo = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<Data>> => {
  return await useOFetch<Data>(
    '/center/cert/list/list',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};

// 获取详情页信息
export const fetchListlOtherInfo = async (
  query = {},
  options?: OFetchRequestOptions,
  fetchContext?: CustomFetchContext
): Promise<ApiResponse<OtherData>> => {
  return await useOFetch<OtherData>(
    '/center/cert/list/data',
    {
      method: 'GET',
      query,
      ...options,
    },
    fetchContext
  );
};
